import { pull } from 'lodash';

export const defaultStylingSchema = ({ schema, formData, intl }) => {
  schema.fieldsets[0].fields.push('backgroundColor');
  // This block won't have a width handler
  pull(schema.fieldsets[0].fields, 'align');
  // schema.properties.align.actions = ['center', 'wide', 'full'];
  return schema;
};
